import * as ReactQuery from 'react-query';
import { InferMutationOptions } from '../../../utils/types';
import { editFusionBatchOrderApi } from './api';

export function useEditFusionBatchOrder(
  options?: InferMutationOptions<typeof editFusionBatchOrderApi>,
) {
  const [editFusionBatchOrder, meta] = ReactQuery.useMutation(
    editFusionBatchOrderApi,
    options,
  );

  return {
    editFusionBatchOrder,
    ...meta,
  };
}
